import { Button } from "@mantine/core";
import { useState } from "react";
import api from "../../../../../../api";
import { useToast } from "../../../../../../mantine/notifications/useToast";
import urls from "../../../../../../urls";
import type { TaskStatusResponse } from "../../../../../../utils/api-utils";
import { pollTaskStatus } from "../../../../../../utils/api-utils";
import type { Todo } from "../../../../../../utils/backend-types";
import { getGenerateDocumentsButtonText } from "./utils/getGenerateDocumentsButtonText";

export interface GenerateDocumentsButtonProps {
  disabled?: boolean;
  todoLabel: string;
  todoId: number;
  onUpdateTodo: (todo: Todo) => void;
}

function GenerateDocumentsButton({
  disabled,
  todoLabel,
  todoId,
  onUpdateTodo
}: GenerateDocumentsButtonProps) {
  const { showToast, showErrorToast } = useToast();
  const [loading, setLoading] = useState(false);

  function handleDone() {
    api
      .get<Todo>(urls.api.todosDetail(todoId))
      .then((response) => {
        onUpdateTodo(response.data);
        showToast({
          type: "success",
          message:
            "Automatische Erstellung war erfolgreich. Neue Dokumente wurden an die Aufgabe angehängt."
        });
      })
      .catch((error) => {
        showErrorToast(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleError(error: unknown) {
    showErrorToast(error);
    setLoading(false);
  }

  function handleSubmit() {
    const url = urls.api.todoGenerateDocuments(todoId);

    setLoading(true);

    api
      .post<TaskStatusResponse>(url, {})
      .then((response) => {
        const taskStatusUrl = response.data.taskStatusUrl;

        if (taskStatusUrl) {
          pollTaskStatus(taskStatusUrl, handleDone, handleError);
        } else {
          handleDone();
        }
      })
      .catch(handleError);
  }

  return (
    <Button
      color="primary"
      disabled={disabled}
      loading={loading}
      onClick={handleSubmit}
    >
      {getGenerateDocumentsButtonText(todoLabel)}
    </Button>
  );
}

export { GenerateDocumentsButton };
